
export const INVALID_TO_SPONSOR = 'red';
export const WARNING_TO_SPONSOR = 'yellow';

export const TYPES_INVITATIONS = {
  SPONSOR_PLAYER: 'Sponsored',
  INVITE_PLAYER: 'Join'
}

export const defaultSponsor = [
  { name: 'Sponsor Player', value: 'Sponsored', type: 'Sponsored' },
  { name: 'Invite Player (without sponsorship)', value: 'Join', type: 'Join' }
];

export const SPONSOR_SELECTED_DEFAULT = { name: 'Sponsor Player', value: 'Sponsored', type: 'Sponsored' };
export const INVITE_SELECTED_DEFAULT = { name: 'Invite Player (without sponsorship)', value: 'Join', type: 'Join' };
